import { CUSTOM_RANGE_LABEL } from '@/constants';

export enum DATE_RANGE_OPTIONS {
  LTM = 'Last 12 Months',
  LTD = 'Last 30 Days',
  YTD = 'Year to Date',
  CUSTOM = 'Custom',
  DEFAULT = 'Any Time',
}

export const DATE_RANGE_OPTION_LABELS: Record<DATE_RANGE_OPTIONS, string> = {
  [DATE_RANGE_OPTIONS.DEFAULT]: DATE_RANGE_OPTIONS.DEFAULT,
  [DATE_RANGE_OPTIONS.LTM]: DATE_RANGE_OPTIONS.LTM,
  [DATE_RANGE_OPTIONS.LTD]: DATE_RANGE_OPTIONS.LTD,
  [DATE_RANGE_OPTIONS.YTD]: DATE_RANGE_OPTIONS.YTD,
  [DATE_RANGE_OPTIONS.CUSTOM]: CUSTOM_RANGE_LABEL,
};

export type SubmitAsOption = {
  label: string;
  value: string;
};

export type DateInput = Date | string | null;
